/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { InvoiceBreakdownPathParams, InvoiceBreakdownResponse } from '../types/InvoiceBreakdown'

/**
 * GET /:organisation/invoices/:invoice/breakdown
 * @see backend/nexus/modules/Billing/Http/Controllers/InvoiceController.php InvoiceController::breakdown
 */
export async function invoiceBreakdown(
	organisation: InvoiceBreakdownPathParams['organisation'],
	invoice: InvoiceBreakdownPathParams['invoice'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<InvoiceBreakdownResponse>> {
	return axiosInstance.get(`/${organisation}/invoices/${invoice}/breakdown`, config)
}
